import {
	ATTEMPT_FETCH_PROGRAMS,
    FETCH_PROGRAMS_SUCCEEDED,
    FETCH_PROGRAMS_FAILED,
    UPDATE_PROGRAMS_TAB,
} from 'shared_redux/actions';

const initialState = {
    isLoading: false,
    currentTab: 'all'
};

export default (state = initialState, action) => {
    switch (action.type) {
		case ATTEMPT_FETCH_PROGRAMS:
			return {
                ...state,
                isLoading: true
            };
        case FETCH_PROGRAMS_SUCCEEDED:
			return {
                ...state,
                isLoading: false
            };
        case FETCH_PROGRAMS_FAILED:
			return {
                ...state,
                isLoading: false
            };
        case UPDATE_PROGRAMS_TAB:
            return {
                ...state,
                currentTab: action.payload
            };
		default:
			return state;
	}
};
